import * as z from 'zod';

import { unitSellBysQuerySchema } from './unit-sell-bys-query-schema';

export const unitSellBysUpdateSchema = unitSellBysQuerySchema
  .omit({ status: true, products_count: true })
  .extend({ status: z.string() });
export type UnitSellBysUpdateSchema = z.infer<typeof unitSellBysUpdateSchema>;

export const unitSellBysCreateSchema = unitSellBysUpdateSchema.omit({ id: true });
export type UnitSellBysCreateSchema = z.infer<typeof unitSellBysCreateSchema>;
